import type { WorkflowGraph } from '../../../api/forms';
import { useHistory, type CommitOptions, type History, type HistoryActions } from '../../../shared/useHistory';

/**
 * Undo, for a canvas that has no Publish button.
 *
 * Every other editing surface in this product is a draft you can walk away
 * from. The workflow deliberately is not — it is live the moment it is clean,
 * exactly as Connections always was — and that makes undo the safety net
 * rather than a convenience. Without it, one mis-drag on a form collecting
 * submissions right now is unrecoverable.
 *
 * The mechanism itself (coalescing a drag into one step, barriers where a
 * connections row went with the change) lives in `shared/useHistory`, which
 * the form builder shares since U4. This is the canvas's typed handle on it.
 */
export type { CommitOptions };
export type GraphHistoryActions = HistoryActions<WorkflowGraph>;
export type GraphHistory = History<WorkflowGraph>;

export function useGraphHistory(): GraphHistory {
  return useHistory<WorkflowGraph>();
}
